module.exports = __webpack_public_path__ + "img/product-placeholder-70.1c73d14.png";